import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IconSVG from 'svg-inline-react'
import { compose } from 'recompose'

import { activeConversationContactTabIndex } from 'app/modules/conversation/selectors'
import { setActiveConversationContactTabIndex } from 'app/modules/conversation/actions'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'

import { Button, Icon, Tabs } from '@driftt/tide-core-legacy'
import Person from './Person'
import Company from './Company'

import * as style from './style.styl'

import collapseRightArrowSrc from '!svg-inline?removeTags=true!images/svg/arrow-solid-right.svg'
import newFeatureBadgeSrc from '!svg-inline?removeTags=true!images/svg/new-feature-badge.svg'

import withEnrichedCompanyData from 'components/hocs/withEnrichedCompanyData'
import withContactInfo from './withContactInfo'

export const PLACEHOLDER_PRIMARY_COLOR = '#E4EFF4'
export const PLACEHOLDER_SECONDARY_COLOR = '#E4EFF4'
export const PLACEHOLDER_PRIMARY_OPACITY = .75
export const PLACEHOLDER_SECONDARY_OPACITY = .4

class ContactSideBar extends Component {
  hideContactSidebar = () => {
    this.props.setEndUserSideBarVisibility(false)
  }

  onActivateTab = (index) => {
    this.props.actions.setActiveConversationContactTabIndex(index)
  }

  render() {
    const {
      conversationId,
      hasDemandbase,
      hasCompanyData,
      isCurrentUserEligibleForRedesignAnnouncement,
      revealContext,
      isTrialEligible,
      ip,
      email
    } = this.props

    const tabData = _.compact([
      {
        title: 'Person',
        component: () => <Person conversationId={conversationId} ip={ip}/>,
      },
      (revealContext.conversationsReveal || hasDemandbase || revealContext.isDriftIntelTrialActive || isTrialEligible) && ({
        title: 'Company',
        component: () => <Company conversationId={conversationId} ip={ip} email={email} {...this.props}/>,
      }),
    ])

    return (
      <div className={style.ContactSideBar}>
        {hasCompanyData && isCurrentUserEligibleForRedesignAnnouncement && (
          <div className="new-feature-badge">
            <IconSVG src={newFeatureBadgeSrc} />
          </div>
        )}
        <Button className={style.hideContactSidebarButton} onClick={this.hideContactSidebar} type="tertiary" size="small">
          <Icon className="contact-icon" name="user" />
          <IconSVG className="collapse-right-arrow-icon" src={collapseRightArrowSrc} />
          Hide
        </Button>
        <Tabs data={tabData} controlled={true} activeTab={this.props.activeConversationTabIndex} onActivateTab={this.onActivateTab} />
      </div>
    )
  }
}

const makeMapStateToProps = () => {

  return (state, props) => {
    return {
      activeConversationTabIndex: activeConversationContactTabIndex(state),
      hasCompanyData: props.companyData && !_.every(props.companyData, (data) => !data || _.isEmpty(data)),
      isCurrentUserEligibleForRedesignAnnouncement: UserPropertiesSelectors.isCurrentUserEligibleForContactSidebarRedesignAnnouncement(state),
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    setActiveConversationContactTabIndex,
  }, dispatch),
})

export default compose(
  withContactInfo,
  connect(makeMapStateToProps, mapDispatchToProps),
  withEnrichedCompanyData)
  (ContactSideBar)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/index.js